import ApiClient from 'api/ApiClient'

class LostReasonsApi extends ApiClient {
  constructor() {
    super({url:'lost_reasons'})
  }
}

export default LostReasonsApi
